export default __webpack_public_path__ + "static/media/supply-package-icon-new.3a558207.svg";